import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Mail, Linkedin, Github, Laptop, Server, Bot, PanelTop, Download, Info, Link2, Code2, LayoutGrid, MessageSquare, ArrowRight } from 'lucide-react';
import { ConfigProvider } from 'antd';
import { useTranslation } from 'react-i18next';
import './App-modern.css';
import Home from './pages/Home';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import Resume from './pages/Resume';

function Navbar() {
  const { i18n, t } = useTranslation();

  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language);
    localStorage.setItem('language', language);
  };

  return (
    <nav className="navbar navbar-pill">
      <div className="nav-pill">
        <div className="nav-pill-links">
          <a href="#experiences">{t('nav.experiences')}</a>
          <a href="#projets">{t('nav.projects')}</a>
        </div>
        <Link to="/" className="nav-pill-avatar">
          <img src="/logo-2.png" width={10} alt="Logo de Néfertiti Dadjo" />
        </Link>
        <div className="nav-pill-links">
          <a href="#services">Compétences</a>
          <a href="#contact">Contact</a>
        </div>

      </div>
    </nav>
  );
}

export { Mail, Linkedin, Github, Laptop, Server, Bot, PanelTop, Download, Info, Link2, Code2, LayoutGrid, MessageSquare, ArrowRight };

function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-brand">
          <span className="footer-name">Néfertiti DADJO</span>
          <p className="footer-tagline">{t('footer.tagline')}</p>
        </div>
        <div className="footer-links">
          <Link to="/" className="footer-link">{t('footer.home')}</Link>
          <Link to="/projects" className="footer-link">{t('footer.projects')}</Link>
          <Link to="/resume" className="footer-link">{t('footer.resume')}</Link>
          <Link to="/contact" className="footer-link">{t('footer.contact')}</Link>
        </div>
        <div className="footer-socials">
          <a href="https://github.com/quantibat" target="_blank" rel="noopener noreferrer" aria-label="GitHub" className="footer-social">
            <Github size={18} />
          </a>
          <a href="https://www.linkedin.com/in/nefertiti-dadjo/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="footer-social">
            <Linkedin size={18} />
          </a>
        </div>
      </div>
      <div className="footer-copyright">
        <p>&copy; 2026 Néfertiti DADJO. {t('footer.copyright')}</p>
      </div>
    </footer>
  );
}

function App() {
  const [grayscaleMode, setGrayscaleMode] = useState(() => localStorage.getItem('grayscale-mode') === 'true');

  useEffect(() => {
    document.body.classList.toggle('grayscale-mode', grayscaleMode);
    localStorage.setItem('grayscale-mode', String(grayscaleMode));
  }, [grayscaleMode]);

  return (
    <ConfigProvider theme={{ token: { colorPrimary: '#7c3aed' } }}>
      <Router>
        <div className="app">
          <Navbar />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home grayscaleMode={grayscaleMode} onToggleGrayscale={() => setGrayscaleMode((enabled) => !enabled)} />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/resume" element={<Resume />} />
            </Routes>
          </main>
          <section className="actions-gallery-footer" aria-label="Photos d'événements et de rencontres professionnelles">
            {['1.jpg', '2.jpg', '4.jpg', '6.jpg'].map((image, index) => (
              <figure className="actions-gallery-item" key={image}>
                <img src={`/actions/${image}`} alt={`Photo d'action ${index + 1}`} loading="lazy" />
              </figure>
            ))}
          </section>
          <Footer />
        </div>
      </Router>
    </ConfigProvider>
  );
}

export default App;
